module.exports = __webpack_public_path__ + "media/location-service_en_ipad_air.c40abafe.mp4";